var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContorno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5233 2.42114C6.55275 2.42114 2.52332 6.45058 2.52332 11.4211C2.52332 16.3917 6.55275 20.4211 11.5233 20.4211C16.4939 20.4211 20.5233 16.3917 20.5233 11.4211C20.5233 6.45058 16.4939 2.42114 11.5233 2.42114ZM0.523315 11.4211C0.523315 5.34601 5.44818 0.421143 11.5233 0.421143C17.5984 0.421143 22.5233 5.34601 22.5233 11.4211C22.5233 17.4963 17.5984 22.4211 11.5233 22.4211C5.44818 22.4211 0.523315 17.4963 0.523315 11.4211Z",
    fill: "#2E334D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5233 6.42114C8.76189 6.42114 6.52332 8.65972 6.52332 11.4211C6.52332 14.1826 8.76189 16.4211 11.5233 16.4211C14.2847 16.4211 16.5233 14.1826 16.5233 11.4211C16.5233 8.65972 14.2847 6.42114 11.5233 6.42114ZM4.52332 11.4211C4.52332 7.55515 7.65732 4.42114 11.5233 4.42114C15.3893 4.42114 18.5233 7.55515 18.5233 11.4211C18.5233 15.2871 15.3893 18.4211 11.5233 18.4211C7.65732 18.4211 4.52332 15.2871 4.52332 11.4211Z",
    fill: "#2E334D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.524 18.4204C18.0763 18.4204 18.524 18.8681 18.524 19.4204V29.421C18.524 29.7676 18.3446 30.0895 18.0498 30.2717C17.755 30.4539 17.3869 30.4705 17.0769 30.3155L11.5232 27.5391L5.97131 30.3154C5.66132 30.4705 5.29317 30.4539 4.99834 30.2717C4.70351 30.0895 4.52405 29.7676 4.52405 29.421V19.4213C4.52405 18.869 4.97176 18.4213 5.52405 18.4213C6.07633 18.4213 6.52405 18.869 6.52405 19.4213V27.8029L11.0759 25.5266C11.3574 25.3859 11.6888 25.3858 11.9703 25.5266L16.524 27.8031V19.4204C16.524 18.8681 16.9718 18.4204 17.524 18.4204Z",
    fill: "#2E334D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContorno);
export default __webpack_public_path__ + "static/media/Contorno.0a3347c1c5909aac0182621a70415586.svg";
export { ForwardRef as ReactComponent };